/**
 * Shown on a draft written from a call that dropped or altered its recorded
 * result (Content.record_mismatch). Word for word the backend's
 * services/public_calls.RECORD_MISMATCH_WARNING.
 */
export const RECORD_MISMATCH_WARNING = 'This draft changed the recorded result — edit before posting'

/**
 * Shown on a stand-in draft (Content.stand_in): template text saved because
 * the AI couldn't be reached. It can't be posted until it's generated again or
 * rewritten. Word for word the backend's services/stand_in.MESSAGE.
 */
export const STAND_IN_MESSAGE =
  "This draft is stand-in text: the AI couldn't be reached when it was made. " +
  'Generate it again, or rewrite it yourself, before posting it.'
